module.exports = __webpack_public_path__ + "img/mv_play.869a8b8.png";